import { lazy } from 'react';
import { withSuspense } from '@/hocs/withSuspense';

export const UserRoutesLazy = withSuspense(
  lazy(() => import('./user-routes').then((module) => ({ default: module.UserRoutes }))),
);
